import React from "react"

class DropdownOrder extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...props
    }
    this.changeOrder = this.changeOrder.bind(this)
  }

  changeOrder() {
    this.props.sortLoans(this.selectInput.value)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }

  render() {
    const { order } = this.state
    const options = [
      { val: "priority"       , text: "Color Priority"  },
      { val: "recent_activity", text: "Recent Activity" },
      { val: "my_action_items", text: "My Action Items" },
      { val: "custom_sort"    , text: "Custom Sort" }
    ]

    return(
      <div className="order-by">
        <label className='inline-box' htmlFor="order-by-select">Order By</label>
        &nbsp;
        <select 
          ref={(input) => { this.selectInput = input }}
          id="order-by-select"
          onChange={this.changeOrder}
          value={order}>
          {options.map(option => <option key={option.val} value={option.val}>{option.text}</option> )}
        </select>
      </div>
    )
  }
}

export default DropdownOrder;

